export default __webpack_public_path__ + "static/media/Archpriest's Crest of Sacrifice.88a71f03.jpg";